import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
  setCollectionProducts(state, payload){
    state.collectionProducts = payload;
  },
  setMainProducts(state, payload) {
    state.mainProducts = payload;
  },
  setAddonProducts(state, payload) {
    state.addonProducts = payload;
  },
  setCardProducts(state, payload) {
    state.cardProducts = payload;
  },
  setDefaultProducts(state, payload) {
    state.defaultProducts = payload;
  },
  setSelectedSort(state,payload){
    state.selectedSort = payload;
  },
  setSelectedProduct(state,payload){
    state.selectedProduct = payload;
  },
  setIsLoading(state,payload){
    state.isLoading = payload;
  },
  setMainCollection(state,payload){
    state.mainCollection = payload
  },
  setCategoriesList(state,payload){
    state.categoriesList = payload;
  },
  setFeeProduct(state,payload){
    state.feeProduct = payload;
  },
  setSelectedBox(state, payload) {
    state.selectedBox = payload;
  },
  setSelectedAddonProducts(state, payload){
    state.selectedAddonProducts = payload;
  },
  updateSelectedAddonProductsNew(state, payload) {
    let product = payload.product;
    let quantity = payload.quantity;
    let currentIndex = state.selectedAddonProducts.findIndex(x => x.variants[0].id == product.variants[0].id);
    if(currentIndex > -1 && quantity > 0){
      state.selectedAddonProducts[currentIndex].quantity = quantity;
    }
    else if(currentIndex > -1 && quantity == 0){
      state.selectedAddonProducts.splice(currentIndex, 1);
    }
    else if(currentIndex < 0 && quantity > 0){
      Vue.set(product, 'quantity', quantity);
      state.selectedAddonProducts.push(product);
    }
  },
  removeSelectedAddonProductNew(state, payload) {
      let currentIndex = state.selectedAddonProducts.findIndex(x => x.id == payload.id);
      if(currentIndex > -1){
        state.selectedAddonProducts.splice(currentIndex, 1);
      }
  },
  setOccasions(state, payload){
    state.occasions = payload;
  },
  setSelectedSortMobile(state,payload){
    state.selectedSortMobile = payload;
  },
  setRangePrice(state,payload){
    Vue.set(state, 'rangePrice', payload);
  },
  setRangePriceMobile(state,payload){
    Vue.set(state, 'rangePriceMobile', payload);
  },
  setAllSelectedOccasion(state,payload){
    state.selectedOccasion = payload;
  },
  setAllSelectedOccasionMobile(state,payload){
    state.selectedOccasionMobile = payload;
  },
  setSelectedOccasion(state,payload){
    let currentIndex = state.selectedOccasion.findIndex(x => x == payload);
    let allIndex = state.selectedOccasion.findIndex(x => x == "View All");
    if(allIndex > -1 && allIndex == currentIndex)
      return
    if(currentIndex > -1){
      state.selectedOccasion.splice(currentIndex, 1);
      if(state.selectedOccasion.length == 0){
        state.selectedOccasion = ["View All"];
      }
    }
    else{
      if(payload == "View All"){
        state.selectedOccasion = ["View All"];
      }
      else{
        state.selectedOccasion.push(payload);
        if(allIndex > -1){
          state.selectedOccasion.splice(allIndex, 1);
        }
      }
    }
  },
  setSelectedOccasionMobile(state,payload){
    let currentIndex = state.selectedOccasionMobile.findIndex(x => x == payload);
    let allIndex = state.selectedOccasionMobile.findIndex(x => x == "View All");
    if(allIndex > -1 && allIndex == currentIndex)
      return
    if(currentIndex > -1){
      state.selectedOccasionMobile.splice(currentIndex, 1);
      if(state.selectedOccasionMobile.length == 0){
        state.selectedOccasionMobile = ["View All"];
      }
    }
    else{
      if(payload == "View All"){
        state.selectedOccasionMobile = ["View All"];
      }
      else{
        state.selectedOccasionMobile.push(payload);
        if(allIndex > -1){
          state.selectedOccasionMobile.splice(allIndex, 1);
        }
      }
    }
  },
};

export default mutations;
